const uniqueId = (() => {
  let num = 0;
  return prefix => {
    num++;
    return `${prefix}-${num}`;
  };
})();

export { uniqueId };
